export default function makeFeaturedPermissionHelpers(accessList, module) {
    const featuredPermission = new Set(accessList);
    function getNode(node, path) {
        if (!path.length) {
            return node;
        }
        const nextNode = node.children.find(({ permission }) => permission === path[0]);
        if (nextNode) {
            return getNode(nextNode, path.slice(1));
        }
        return {};
    }
    function enabledPermissionByTreeConfig(permission) {
        const permissionTree = { children: module.permissionTree || [] };
        const path = permission.split('.');
        let node;
        if (path[0] === module.group) {
            if (path[1] === module.id) {
                const slice = 2;
                node = getNode(permissionTree, path.slice(slice));
            }
            else {
                const slice = 1;
                node = getNode(permissionTree, path.slice(slice));
            }
        }
        else if (path[0] === module.id) {
            const slice = 1;
            node = getNode(permissionTree, path.slice(slice));
        }
        else {
            node = getNode(permissionTree, path);
        }
        return !node.disabled;
    }
    function enabledPermissionByAccessList(permission) {
        return (!permission ||
            featuredPermission.has(permission) ||
            featuredPermission.has(`${module.id}.${permission}`) ||
            featuredPermission.has(`${module.group}.${module.id}.${permission}`));
    }
    function enabledPermission(permission) {
        return (enabledPermissionByAccessList(permission) ||
            enabledPermissionByTreeConfig(permission));
    }
    return {
        enabledPermissionByAccessList,
        enabledPermission,
    };
}
